import { Route } from 'react-router-dom';
import SkeletonPage from '../modules/skeleton/SkeletonPage';
import { Suspense, lazy } from 'react';
import PRIVILEGES from '../constants/privileges';
import { RBACRoute } from '../routes/RBACRoute';

const Stocks = lazy(() => import('../modules/stocks'));

const StocksTable = lazy(
  () => import('../modules/stocks/pages/StocksTable')
);

const StockIssueKanban = lazy(
  () => import('../modules/stocks/pages/StockIssueKanban')
);

const RaiseRequestPage = lazy(
  () => import('../modules/stocks/pages/RaiseRequestPage')
);

const StockIssueDetailPage = lazy(
  () => import('../modules/stocks/pages/StockIssueDetailPage')
);

const StocksRoutes = (
  <>
    <Route
      path="stocks"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <Stocks />
        </Suspense>
      }
    >
      <Route
        path=""
        element={
          <Suspense fallback={<SkeletonPage />}>
            <StocksTable />
          </Suspense>
        }
      />
      <Route
        path="issue-stock"
        element={
          <Suspense fallback={<SkeletonPage />}>
            <StockIssueKanban />
          </Suspense>
        }
      />

      <Route
        path="issue-stock/create"
        element={
          <RBACRoute privileges={[PRIVILEGES.COMMON.GLOBAL_STOCK_ISSUE_CREATE]}>
            <Suspense fallback={<SkeletonPage />}>
              <RaiseRequestPage />
            </Suspense>
          </RBACRoute>
        }
      />
      <Route
        path="issue-stock/edit/:id"
        element={
          <RBACRoute privileges={[PRIVILEGES.COMMON.GLOBAL_STOCK_ISSUE_UPDATE]}>
            <Suspense fallback={<SkeletonPage />}>
              <RaiseRequestPage />
            </Suspense>
          </RBACRoute>
        }
      />
      <Route
        path="issue-stock/details/:id"
        element={
          <RBACRoute privileges={[PRIVILEGES.COMMON.GLOBAL_STOCK_ISSUE_DETAIL_VIEW]}>
            <Suspense fallback={<SkeletonPage />}>
              <StockIssueDetailPage />
            </Suspense>
          </RBACRoute>
  }
      />
    </Route>
  </>
);

export default StocksRoutes; 